export const POST_LOGIN_RETURN_KEY = 'postLoginReturnTo';

export function isUnauthorizedError(error: Error): boolean {
  return /^401: .*Unauthorized/.test(error.message);
}

export function redirectToLogin(delayMs = 0): void {
  const go = () => {
    if (window.location.pathname !== '/login') {
      const returnTo = encodeURIComponent(window.location.pathname + window.location.search);
      window.location.href = `/login?returnTo=${returnTo}`;
    }
  };
  if (delayMs && delayMs > 0) {
    setTimeout(go, delayMs);
  } else {
    go();
  }
}
